import { attr, fk } from 'redux-orm';
import { BaseModel } from './base';
import { ThreadStatus, LinkedInSentMessageError } from '../const/enum';

export interface ISentMessage {
    threadId: string;
    message: string;
    timestamp: string;
    orgMemberId: string;
    contactId: string;
    dateCreated: string;
    status: ThreadStatus;
    error: LinkedInSentMessageError;
    id: string;
    isContactDeleted: boolean;
}

export class SentMessage extends BaseModel<typeof SentMessage, ISentMessage> {
    static modelName = 'SentMessage';
    static fields = {
        id: attr(),
        threadId: attr(),
        message: attr(),
        contactId: attr(),
        dateCreated: attr(),
        timestamp: attr(),
        orgMemberId: fk({ to: 'OrganizationMember', as: 'organizationMember' }),
        status: attr(),
        error: attr(),
        isContactDeleted: attr(),
    };
}
